import styled from 'styled-components';

export const SpanStyled = styled.span`
  font-size: 12px;
  font-weight: 400;
  font-family: ${props => (props.theme.fonts)};
  color: #353538;
`
